(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sc-waterjet-booking"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DOW = ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'];
    var DAYN = ['Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag'];
    var DAYS = ['Man', 'Tir', 'Ons', 'Tor', 'Fre'];
    var MON = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
    var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    var VATTXT = '<span class="vat-incl">inkl. moms</span><span class="vat-excl">ekskl. moms</span>';

    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var hh = function (h) { return pad(h) + ':00'; };
    var iso = function (d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); };
    var parse = function (s) { var a = s.split('-'); return new Date(+a[0], a[1] - 1, +a[2]); };
    var addDays = function (s, n) { var d = parse(s); d.setDate(d.getDate() + n); return iso(d); };
    var monday = function (s) { var d = parse(s); return addDays(s, -((d.getDay() + 6) % 7)); };
    var fd = function (s) { var d = parse(s); return DOW[d.getDay()] + ' ' + d.getDate() + '. ' + MON[d.getMonth()]; };
    var dm = function (s) { var d = parse(s); return d.getDate() + '. ' + MON[d.getMonth()]; };
    var isoWeek = function (s) { var d = parse(s); d.setDate(d.getDate() + 3 - ((d.getDay() + 6) % 7)); var w1 = new Date(d.getFullYear(), 0, 4); return 1 + Math.round(((d - w1) / 864e5 - 3 + ((w1.getDay() + 6) % 7)) / 7); };
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var money = function (cents) { return (Math.round(cents) / 100).toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr'; };
    // Viser prisen inkl. moms for private og ekskl. moms for erhverv (temaets Privat/Erhverv-valg)
    var vat = function (incl, excl) { return '<span class="vat-incl">' + money(incl) + '</span><span class="vat-excl">' + money(excl) + '</span>'; };

    function boot(root) {
      if (root.__wj) return;
      var cfgEl = root.querySelector('[data-config]');
      if (!cfgEl) return;
      root.__wj = true;
      var cfg = JSON.parse(cfgEl.textContent);
      var q = function (s) { return root.querySelector(s); };
      var field = function (n) { return q('[data-f="' + n + '"]'); };
      var val = function (n) { var el = field(n); return el ? el.value.trim() : ''; };

      var BASE = String(cfg.projekt || '').trim().replace(/\/+$/, '');
      var WEEKS = Math.max(1, Math.min(8, Number(cfg.weeks) || 8));
      // Hentes fra Projekt (Indstillinger) – standardværdierne bruges kun, indtil de er hentet
      var OPEN = 8, CLOSE = 15, MAXH = 8, MINH = 1, RATE = 0, RATEX = 0; // øre pr. time inkl./ekskl. moms
      var minWeek = (function () { var d = new Date(); if (d.getDay() === 6) d.setDate(d.getDate() + 2); else if (d.getDay() === 0) d.setDate(d.getDate() + 1); return monday(iso(d)); })();
      var maxWeek = addDays(minWeek, 7 * (WEEKS - 1));
      var S = { week: minWeek, col: 0, day: null, start: null, hours: 1, callback: false, slots: {}, ready: false, live: false, failed: false, sending: false, first: true };
      var SB = null, timer = null;

      function rpc(name, args) {
        return fetch(SB.url + '/rest/v1/rpc/' + name, {
          method: 'POST', cache: 'no-store',
          headers: { apikey: SB.key, Authorization: 'Bearer ' + SB.key, 'Content-Type': 'application/json' },
          body: JSON.stringify(args || {})
        }).then(function (r) { if (!r.ok) throw new Error('rpc ' + r.status); return r.json(); });
      }
      function setup() {
        return fetch(BASE + '/api/config', { cache: 'no-store' })
          .then(function (r) { if (!r.ok) throw new Error('config ' + r.status); return r.json(); })
          .then(function (c) { SB = { url: c.supabaseUrl, key: c.supabaseAnonKey }; return rpc('public_booking_info'); })
          .then(function (i) {
            OPEN = +i.open_hour; CLOSE = +i.close_hour;
            MAXH = Math.min(+i.max_booking_hours || (CLOSE - OPEN), CLOSE - OPEN);
            MINH = Math.max(1, Math.ceil((+i.min_booking_minutes || 60) / 60));
            RATEX = Math.round(+i.hourly_rate * 100);
            RATE = Math.round(+i.hourly_rate * (1 + (+i.vat_rate || 0)) * 100);
            S.hours = Math.max(MINH, Math.min(S.hours, MAXH));
            S.ready = true;
            q('[data-rate]').innerHTML = vat(RATE, RATEX) + '<small>' + VATTXT + '</small>';
            q('[data-open]').innerHTML = 'Man–fre ' + pad(OPEN) + '–' + pad(CLOSE) + '<small>Mindst ' + MINH + ' time' + (MINH > 1 ? 'r' : '') + (i.min_lead_hours ? ', ' + i.min_lead_hours + ' t varsel' : '') + '</small>';
            if (i.address) q('[data-address]').textContent = i.address;
          });
      }
      function load() {
        return (SB ? Promise.resolve() : setup())
          .then(function () { return rpc('get_availability', { p_from: minWeek, p_to: addDays(maxWeek, 4) }); })
          .then(function (rows) {
            var m = {};
            rows.forEach(function (x) { m[x.day + '|' + x.slot] = x.status; });
            S.slots = m; S.live = true; S.failed = false;
            if (S.first) { S.first = false; jumpToFree(); }
            render();
          })
          .catch(function () { S.live = false; S.failed = true; render(); });
      }
      // Projekt giver halve timer: en hel time er ledig, når begge halvdele er ledige
      function state(day, h) {
        if (!S.live) return S.failed ? 'past' : 'load';
        var a = S.slots[day + '|' + h * 60], b = S.slots[day + '|' + (h * 60 + 30)];
        if (a === 'ledig' && b === 'ledig') return 'free';
        if (a === 'optaget' || b === 'optaget') return 'busy';
        return 'past';
      }
      function dayFree(day) { for (var h = OPEN; h < CLOSE; h++) if (state(day, h) === 'free') return true; return false; }
      function firstFreeCol(week) { for (var i = 0; i < 5; i++) if (dayFree(addDays(week, i))) return i; return -1; }
      // Første gang: spring frem til den første uge med ledige tider (højst 4 uger)
      function jumpToFree() {
        var w = S.week;
        for (var n = 0; n < 4 && w < maxWeek && firstFreeCol(w) < 0; n++) w = addDays(w, 7);
        if (firstFreeCol(w) >= 0) S.week = w;
        S.col = Math.max(0, firstFreeCol(S.week));
      }
      function maxFrom(day, start) { var n = 0; for (var h = start; h < CLOSE && n < MAXH && state(day, h) === 'free'; h++) n++; return n; }
      function fullDayOk(day) { return CLOSE - OPEN <= MAXH && !!day && maxFrom(day, OPEN) >= CLOSE - OPEN; }
      function isFullDay() { return S.start === OPEN && S.hours === CLOSE - OPEN; }
      function pick(group) { var b = root.querySelector('[data-group="' + group + '"] [aria-pressed="true"]'); return b ? b.textContent : ''; }
      function showErr(msg, focus) {
        var e = q('[data-error]'); e.textContent = msg || ''; e.hidden = !msg;
        if (focus && field(focus)) field(focus).focus();
      }

      function render() {
        if (S.day && S.start != null && S.live) {
          var m = maxFrom(S.day, S.start);
          if (m < (S.callback ? 1 : MINH)) { showErr('Tiden ' + fd(S.day) + ' kl. ' + hh(S.start) + ' er netop blevet booket. Vælg en ny tid.'); S.day = null; S.start = null; }
          else if (S.hours > m) S.hours = m;
        }
        var days = [0, 1, 2, 3, 4].map(function (i) { return addDays(S.week, i); });
        q('[data-week]').textContent = 'Uge ' + isoWeek(S.week) + ' · ' + dm(days[0]) + ' – ' + dm(days[4]);
        var live = q('[data-live]');
        live.textContent = S.live ? 'Live – opdateres automatisk'
          : S.failed ? (cfg.design ? 'Kan ikke hente tider. Tjek at butikkens adresse står i BOOKING_ORIGINS i Vercel.' : 'Kunne ikke hente ledige tider – prøv igen om lidt')
          : 'Henter ledige tider…';
        live.className = 's-wj-live' + (S.live ? ' on' : S.failed ? ' off' : '');
        q('[data-prev]').disabled = S.week <= minWeek;
        q('[data-next]').disabled = S.week >= maxWeek;

        q('[data-days]').innerHTML = days.map(function (d, i) {
          return '<button type="button" class="s-wj-day' + (i === S.col ? ' on' : '') + '" data-col="' + i + '" aria-pressed="' + (i === S.col) + '"><b>' + DAYS[i] + '</b><span>' + parse(d).getDate() + '/' + (parse(d).getMonth() + 1) + '</span><i class="' + (dayFree(d) ? 'y' : 'n') + '"></i></button>';
        }).join('');

        var off = function (i) { return i === S.col ? '' : ' class="m-off"'; };
        var html = '<thead><tr><th><span class="s-vh">Tid</span></th>' + days.map(function (d, i) { return '<th' + off(i) + '>' + DAYN[i] + '<small>' + dm(d) + '</small></th>'; }).join('') + '</tr></thead><tbody>';
        for (var h = OPEN; h < CLOSE; h++) {
          html += '<tr><td class="h">' + hh(h) + '</td>';
          days.forEach(function (d, i) {
            var st = state(d, h), sel = S.day === d && S.start != null && h >= S.start && h < S.start + (S.callback ? 1 : S.hours);
            if (st === 'free') html += '<td' + off(i) + '><button type="button" class="s-wj-slot' + (sel ? ' sel' : '') + '" data-slot="' + d + '|' + h + '" aria-pressed="' + sel + '" aria-label="' + fd(d) + ' kl. ' + hh(h) + '">' + (sel ? (S.callback ? 'Ønsket' : 'Valgt') : 'Ledig') + '</button></td>';
            else html += '<td' + off(i) + '><div class="s-wj-slot ' + st + '">' + (st === 'busy' ? 'Optaget' : st === 'past' ? '–' : '') + '</div></td>';
          });
          html += '</tr>';
        }
        q('[data-cal]').innerHTML = html + '</tbody>';

        var has = S.day && S.start != null, max = has ? maxFrom(S.day, S.start) : 0;
        q('[data-hours]').textContent = S.callback ? '?' : S.hours + ' t';
        q('[data-minus]').disabled = !has || S.callback || S.hours <= MINH;
        q('[data-plus]').disabled = !has || S.callback || S.hours >= max;
        var fdBtn = q('[data-fullday]');
        fdBtn.hidden = !S.ready || CLOSE - OPEN > MAXH;
        fdBtn.disabled = S.callback || !fullDayOk(S.day);
        fdBtn.setAttribute('aria-pressed', has && !S.callback && isFullDay() ? 'true' : 'false');
        fdBtn.textContent = 'Hel dag ' + pad(OPEN) + '–' + pad(CLOSE);
        q('[data-callback]').setAttribute('aria-pressed', S.callback ? 'true' : 'false');
        q('[data-hint]').textContent = S.callback ? 'Vælg den dag og tid, du helst vil komme. Vi ringer og hjælper med at vurdere, hvor lang tid opgaven tager.'
          : has ? 'Ledigt i træk fra ' + hh(S.start) + ': ' + max + ' t' : 'Klik på en ledig tid i kalenderen.';

        var time = has ? fd(S.day) + ' kl. ' + hh(S.start) + (S.callback ? ' (ønsket)' : '–' + hh(S.start + S.hours)) : 'Vælg i kalenderen';
        var sum = '<div><span>Opgave</span><span>' + esc(pick('opgave')) + ' · ' + esc(pick('materiale')) + '</span></div><div><span>Tid</span><span>' + time + '</span></div>';
        if (S.callback) sum += '<div><span>Pris</span><span>' + (RATE ? vat(RATE, RATEX) + ' / time' : '–') + '</span></div>';
        else sum += '<div><span>Pris</span><span>' + (has && RATE ? S.hours + ' t × ' + vat(RATE, RATEX) : '–') + '</span></div>' +
          '<div class="tot"><span>I alt ' + VATTXT + '</span><span>' + (has && RATE ? vat(S.hours * RATE, S.hours * RATEX) : '–') + '</span></div>' +
          '<small class="vat-excl">Moms lægges til ved betalingen.</small>';
        q('[data-sum]').innerHTML = sum;

        field('email').required = !S.callback;
        q('[data-email-label]').textContent = S.callback ? 'E-mail (valgfri)' : 'E-mail';
        q('[data-terms-row]').hidden = S.callback;
        if (!S.sending) q('[data-go]').textContent = S.callback ? 'Ring mig op' : 'Gå til betaling';
        q('[data-paynote]').textContent = S.callback
          ? 'Tiden er ikke reserveret, før vi har talt sammen. Prisen er den samme som ved online booking.'
          : 'Du betaler hos ' + (cfg.partner || 'vores samarbejdspartner') + ' med kort, MobilePay m.m. Tiden holdes til dig, mens du betaler, og du får kvittering på mail.';
      }

      function done(name, phone, ref) {
        q('[data-steps]').hidden = true;
        var box = q('[data-done]');
        box.innerHTML = '<strong>Tak, ' + esc(name.split(' ')[0]) + '!</strong>Vi ringer dig op på ' + esc(phone) + ' og aftaler tiden med dig.' + (ref ? ' Dit referencenummer er <b>' + esc(ref) + '</b>.' : '');
        box.hidden = false; box.focus();
      }

      function submit(btn) {
        if (!S.ready) return showErr('Kalenderen er ikke indlæst endnu. Prøv igen om lidt.');
        if (!S.day || S.start == null) return showErr(S.callback ? 'Vælg den dag og tid, du helst vil komme.' : 'Vælg en ledig tid i kalenderen.');
        var name = val('name'), email = val('email'), phone = val('phone');
        if (!name) return showErr('Skriv dit navn.', 'name');
        if (phone.replace(/\D/g, '').length < 8) return showErr('Skriv dit telefonnummer.', 'phone');
        if ((!S.callback || email) && !EMAIL.test(email)) return showErr('Skriv en gyldig e-mail.', 'email');
        if (!S.callback && !q('[data-terms]').checked) return showErr('Sæt flueben ved betingelserne.');
        var company = val('company');
        showErr(''); S.sending = true; btn.disabled = true; btn.classList.add('loading');
        btn.textContent = S.callback ? 'Sender…' : 'Holder tiden…';
        fetch(BASE + '/api/book', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            day: S.day, start: S.start * 60, minutes: S.callback ? 0 : S.hours * 60,
            name: name, email: email, phone: phone, cvr: val('cvr'),
            note: [pick('opgave'), company ? 'Firma: ' + company : '', val('note'), 'Booket via ' + location.hostname].filter(Boolean).join(' · '),
            ref: pick('materiale'),
            website: val('website')
          })
        })
          .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (x) {
            if (!x.ok) throw new Error(x.d.error || '');
            if (x.d.callback) { S.sending = false; return done(name, phone, x.d.ref); }
            if (!x.d.url) throw new Error('');
            window.location.href = x.d.url;
          })
          .catch(function (e) {
            S.sending = false; btn.disabled = false; btn.classList.remove('loading');
            var msg = e && e.message && !/fetch|network|load failed/i.test(e.message) ? e.message : 'Bookingen kunne ikke oprettes. Prøv igen, eller kontakt os.';
            render(); showErr(msg); load();
          });
      }

      root.addEventListener('click', function (ev) {
        var t = ev.target.closest('button');
        if (!t || !root.contains(t) || S.sending) return;
        if (t.dataset.slot) {
          var p = t.dataset.slot.split('|');
          S.day = p[0]; S.start = +p[1];
          S.hours = Math.max(MINH, Math.min(S.hours, maxFrom(S.day, S.start)));
          showErr(''); render(); return;
        }
        if (t.dataset.col) { S.col = +t.dataset.col; render(); return; }
        if (t.hasAttribute('data-prev')) { S.week = addDays(S.week, -7); S.col = Math.max(0, firstFreeCol(S.week)); render(); return; }
        if (t.hasAttribute('data-next')) { S.week = addDays(S.week, 7); S.col = Math.max(0, firstFreeCol(S.week)); render(); return; }
        if (t.hasAttribute('data-minus')) { S.hours = Math.max(MINH, S.hours - 1); render(); return; }
        if (t.hasAttribute('data-plus')) { S.hours = Math.min(maxFrom(S.day, S.start), S.hours + 1); render(); return; }
        if (t.hasAttribute('data-fullday')) {
          if (fullDayOk(S.day)) { S.start = OPEN; S.hours = CLOSE - OPEN; showErr(''); }
          render(); return;
        }
        if (t.hasAttribute('data-callback')) { S.callback = !S.callback; showErr(''); render(); return; }
        var g = t.closest('[data-group]');
        if (g) { g.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', b === t ? 'true' : 'false'); }); render(); return; }
        if (t.hasAttribute('data-go')) submit(t);
      });

      function start() {
        if (timer) return;
        load();
        timer = setInterval(function () {
          if (!document.body.contains(root)) return clearInterval(timer);
          if (!document.hidden && !S.sending) load();
        }, 30000);
      }
      render();
      // Henter først tiderne, når kunden nærmer sig sektionen
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); start(); } }, { rootMargin: '600px 0px' });
        io.observe(root);
      } else start();
    }

    function all() { document.querySelectorAll('[data-wj]').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-wj]').forEach(boot); });
  })();

  } catch(e) { console.error(e); }
})();
})();
